module.exports = __webpack_public_path__ + "static/blog-thumb-2-7a3eadb95c8750b6a8a5931f09b0f3c0.jpg";